import {docsStore} from '../stores';
import {DocsService} from '../services';

export async function fetchDocs() {

  const {docs, version} = await DocsService.fetchDocs();
  // const {components, props} = docs;
  docsStore.setDocs(docs);
  docsStore.setVersion(version);
}



// WEBPACK FOOTER //
// ./actions/docs.js